<template>
    <div>
        <div class="seachBox flex">

            <div class="seachList"><span class="name">客户名称：</span>
                <a-input  class="search-input seachs" allowClear placeholder="请输入客户名称搜索" v-model="seach.name"/>
            </div>
            <div class="seachList"><span class="name">行业：</span>
<!--                <a-select v-model="seach.industry_id" class="seachs" allowClear>-->
<!--                    <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.industry">-->
<!--                        {{item.name}}-->
<!--                    </a-select-option>-->
<!--                </a-select>-->

              <a-cascader class="seachs"  :load-data="loadData"   :fieldNames="fieldNames"
                          v-model="seach.industry_id"
                          :options="seachList.industry"
                          change-on-select placeholder="请选择"
              />
            </div>
            <div class="seachList"><span class="name">产品数：</span>
                <a-input-number :precision="0" v-model="seach.product_min_num" class="num_input" />
                ~
                <a-input-number :precision="0" v-model="seach.product_max_num" class="num_input" />
            </div>

            <div class="seachList"><span class="name">新闻数：</span>
                <a-input-number :precision="0" v-model="seach.news_min_num" class="num_input" />
                ~
                <a-input-number :precision="0" v-model="seach.news_max_num" class="num_input" />
            </div>

            <div class="seachList no"></div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
            <div class="  seachBtnBox"  >
                <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
                    查询
                </a-button>
                <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button>
            </div>
        </div>

        <div>
            <a-button class="top_btn" type="primary" @click=" exper">
                批量导出
            </a-button>
        </div>
        <a-table :columns="columns" :data-source="datas" :loading="loading" :pagination="pagination" rowKey="id"  :scroll="{ x: 1300 }"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
          <span slot="industry_name" slot-scope="text, record" :title="text" style="word-break:break-all;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;" >{{text}}</span>

        </a-table>

    </div>
</template>

<script>
    import API from "../api";
    import moment from 'moment';
    import {changStatus, removeById, orderList} from "../../../../utils/utils"

    const columns = [
        {
            title: "客户名称",
            dataIndex: "company",
            key: "company",
            width: "120px",
            ellipsis: true,
        },

      {
        title: "行业",
        dataIndex: "industry_name",

        width: "200px",
        key: "industry_name",
        scopedSlots: {customRender: "industry_name"}
      },
        {
            title: "主营产品",
            dataIndex: "main_products",
            ellipsis: true,
            width: "150px",
            key: "main_products",
        },
        {
            title: "产品数",
            dataIndex: "product_num_count",
            ellipsis: true,
            width: "150px",
            key: "product_num_count",
        },
        {
            title: "新闻数",
            key: "news_num_count",
            dataIndex: "news_num_count",
            width: "150px",
        },
        {
            title: "产品页面平均字符数量",
            key: "product_content_count_avg",
            dataIndex: "product_content_count_avg",
            width: "180px",
        },
        {
            title: "新闻页面平均字符数量",
            key: "news_content_count_avg",
            dataIndex: "news_content_count_avg",
            width: "180px",
        },
    ];
    export default {
        name: "index",
        data() {
            return {fieldNames: {label: 'name', value: 'id', children: 'children'},
                seach: {
                    name: "",
                    industry_id: "",
                    product_min_num: "",
                    product_max_num: "",
                    news_min_num: "",
                    news_max_num: "",
                },
                seachList: {
                    industry: [],
                },
                exportData:{},
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                datas: [],
                columns,
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/ProductArticle"; //设置左侧导航2-2 active
        },

        mounted() {
            this.getList()
          this.getIndustry()
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
          loadData(selectedOptions) {
            const targetOption = selectedOptions[selectedOptions.length - 1];
            targetOption.loading = true;
            let THAT=this
            API.server.GET_INDUSTRY_LIST({parent_id: selectedOptions[selectedOptions.length-1].id}).then(res => {
              targetOption.loading = false;
              targetOption.children = res.data.data
              THAT.seachList.industry=[...THAT.seachList.industry]
            })

          },
            exper(id) {
                API.server.EXPORT({...this.exportData,ids:this.selectedRowKeys}).then(res => {
                    window.open(`${this.$store.state.urlExper}${res.data.data.path.substr(1)}`)
                    // this.getList()
                    // this.selectedRowKeys = []
                })
            },
            resetSeach() {
                this.loading = true
                this.seach = {
                    name: "",
                    industry_id: "",
                    product_min_num: "",
                    product_max_num: "",
                    news_min_num: "",
                    news_max_num: "",
                }
                this.getList(1)
            },
            getList(page) {
                let seachData = JSON.parse(JSON.stringify(this.seach))
                if (seachData.product_min_num > seachData.product_max_num &&seachData.product_max_num!=""&&seachData.product_min_num!=""  &&seachData.product_max_num!=null&&seachData.product_min_num!=null || seachData.news_min_num > seachData.news_max_num&&seachData.news_max_num!=""&&seachData.news_min_num!=""  &&seachData.news_max_num!=null&&seachData.news_min_num!=null  ) {
                    this.$message.warning('后面输入框数字不能小于前面输入框数字');
                    // 输入框数字需大于等于0，并且
                    return
                }
                this.exportData=seachData
                API.server.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.datas = res.data.data.data.data
                    this.pagination.total = res.data.data.data.total
                    this.pagination.pageSize = res.data.data.data.per_page
                    this.pagination.current = res.data.data.data.current_page

                    this.selectedRowKeys=[]
                    this.loading = false

                })
            },
          getIndustry(){
            API.server.GET_INDUSTRY_LIST({parent_id:0}).then(res => {
              this.seachList.industry = res.data.data
            })
          },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },

        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }
    .num_input{width:30%}
    .search-group .search-input {
        width: 200px;height: 32px;
        margin: 0 8px 0 0 ;
    }
</style>
